function cardWidgetPaging(widgetIdentifier, isManual) {
    var pagingGuidsInput = $("#" + widgetIdentifier + "_pagingGuidsInputTest").val();
    var currentDisplayCount = $("#" + widgetIdentifier + "_currentDisplayCountSpan").html();
    var totalRecordCountInput = $("#" + widgetIdentifier + "_totalRecordCountInputTest").val();
    var cardWidgetPropertiesTests = $("#" + widgetIdentifier + "_cardWidgetPropertiesTest").val();
    var resultsContainer = $("#" + widgetIdentifier + "_card-group__list");    
    var apiUrl = '/cardpaging';
    if (isManual) {
        apiUrl = '/manuallycuratedcardpaging';
    } 

    $.ajax({
        url: apiUrl,
        data: {
            pagingGuidsTest: pagingGuidsInput,
            currentDisplayCount: currentDisplayCount,
            totalRecordCount: totalRecordCountInput,
            cardWidgetProperties: cardWidgetPropertiesTests
        },
        contentType: 'application/x-www-form-urlencoded',
        method: "POST",
        success: function (result) {
            //Append new results. Update counters.
            resultsContainer.append(result.view);

            $("#" + widgetIdentifier + "_currentDisplayCountSpan").html(result.newCount);
            currentDisplayCount = result.newCount;

            //We are at the end of the results. Hide load more.
            if (result.newCount == result.totalRecordCount) {
                $("#" + widgetIdentifier + "_loadMoreResultCards").hide();
            }

        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert("Status: " + textStatus); alert("Error: " + errorThrown);
        }
    });
}